import request from "_private/utils/request";

/**
 * @description  对接信息汇总列表接口
 * @author wangzhenxuan
 * @export
 * @param {*} data
 * @returns
 */
export function findByPage(data) {
  return request({
    url: "/report/dockNumReport/findByPage",
    method: "post",
    headers: { type: "json" },
    data
  });
}
